import React from "react";
import styled from "styled-components";
import Image from "gatsby-image";
import { Body, DomeText, Header2 } from "./typography";
import { Colors } from "./styles/Colors";
import Breakpoints from "./styles/Breakpoints";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;

  background: ${(props) => props.color};

  color: ${(props) => (props.light ? Colors.cream2 : Colors.grey)};

  > div:first-child {
    padding: 64px 32px;

    > div {
      display: flex;

      align-items: center;

      margin-bottom: 24px;

      img {
        width: 50px;
        height: 50px;

        margin-right: 16px;
      }

      ${DomeText} {
        color: ${(props) => (props.light ? Colors.cream2 : Colors.grey)};
      }
    }
  }

  @media ${Breakpoints.tablet} {
    flex-direction: row;

    > div:first-child {
      padding: 64px 96px;

      flex: 0 0 50%;

      display: flex;
      flex-direction: column;

      justify-content: center;
    }

    > div:last-child {
      flex: 0 0 50%;
    }
  }

  @media ${Breakpoints.desktop} {
    > div:first-child {
      flex: 0 0 40%;
    }

    > div:last-child {
      flex: 0 0 60%;
    }
  }
`;

const QuoteText = styled(Header2)`
  margin-bottom: 40px;

  svg {
    display: block;

    width: 24px;

    margin-bottom: 8px;
  }

  @media ${Breakpoints.tablet} {
    svg {
      width: 48px;

      position: relative;

      top: 30px;
      left: -54px;
    }
  }
`;

const QUOTE_SVG = (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 20">
    <defs />
    <path
      fill="#CBE6E2"
      d="M11 1.5L10 0C3.8 2.5 0 9 0 13.8c0 3.7 2.2 5.7 4.6 5.7 2.5 0 4.5-2 4.5-4.6 0-2.3-1.7-4.7-4.7-4.5C5 7 7.5 3.6 11 1.5zm6.5 8.9A14 14 0 0124 1.5L23 0c-6.2 2.5-10 9-10 13.8 0 3.7 2.2 5.7 4.7 5.7s4.5-2 4.5-4.6c0-2.3-1.7-4.7-4.7-4.5z"
      opacity=".3"
    />
  </svg>
);

export default function BaldJourneyStage({
  quote,
  icon,
  stage,
  description,
  illustration,
  color,
  light,
}) {
  return (
    <Wrapper color={color} light={light}>
      <div>
        <QuoteText>
          {QUOTE_SVG}
          {quote}
        </QuoteText>
        <div>
          <img src={icon} />
          <DomeText>{stage}</DomeText>
        </div>
        <Body>{description}</Body>
      </div>
      <Image fluid={illustration} />
    </Wrapper>
  );
}
